import { useEffect } from "react";

// Lightweight per-route meta (sets tags on the rendered DOM; the static head in
// public/index.html is the crawler floor). Avoids the react-helmet-async dep.
export const Seo = ({ title, description, path = "/", image = "/img/hero.jpg", noindex = false }) => {
  useEffect(() => {
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    const abs = (p) => `${origin}${p}`;
    document.title = title;

    const upsert = (selector, attrs, content) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement(attrs.tag || "meta");
        document.head.appendChild(el);
      }
      if (attrs.rel) el.setAttribute("rel", attrs.rel);
      if (attrs.property) el.setAttribute("property", attrs.property);
      if (attrs.name) el.setAttribute("name", attrs.name);
      el.setAttribute("content", content);
    };

    upsert('meta[name="description"]', { name: "description" }, description);
    if (noindex) {
      upsert('meta[name="robots"]', { name: "robots" }, "noindex, nofollow");
    } else {
      upsert('meta[name="robots"]', { name: "robots" }, "index, follow, max-image-preview:large, max-snippet:-1");
    }
    upsert('link[rel="canonical"]', { rel: "canonical" }, `https://hauntedminka.com${path}`);
    upsert('meta[property="og:title"]', { property: "og:title" }, title);
    upsert('meta[property="og:description"]', { property: "og:description" }, description);
    upsert('meta[property="og:url"]', { property: "og:url" }, `https://hauntedminka.com${path}`);
    upsert('meta[property="og:image"]', { property: "og:image" }, `https://hauntedminka.com${image}`);
    upsert('meta[name="twitter:title"]', { name: "twitter:title" }, title);
    upsert('meta[name="twitter:description"]', { name: "twitter:description" }, description);
    upsert('meta[name="twitter:image"]', { name: "twitter:image" }, `https://hauntedminka.com${image}`);
  }, [title, description, path, image, noindex]);
  return null;
};
